import { SimulateMultiPopupComponent } from './simulate-multi-popup.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxDataGridModule, DxChartModule, DxTextAreaModule, DxPopupModule, DxRangeSelectorModule, DxAutocompleteModule, DxValidatorModule, DxValidationSummaryModule, DxDateBoxModule, DxTooltipModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';


@NgModule({
	declarations: [SimulateMultiPopupComponent],
	imports: [
		CommonModule,
		DxDataGridModule,
		DxChartModule,
		DevEpressCommonModule,
		DxTextAreaModule,
		DxPopupModule,
		DxRangeSelectorModule,
		DxAutocompleteModule,
		DxValidatorModule,
		DxValidationSummaryModule,
		DxDateBoxModule,
		DxTooltipModule,
	],
	exports: [SimulateMultiPopupComponent]
})
export class SimulateMultiPopupModule { }
